import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/loading.tsx");
